import { render, staticRenderFns } from "./CtintMultipleTabCategoryMain.vue?vue&type=template&id=ca12812c&"
import script from "./CtintMultipleTabCategoryMain.vue?vue&type=script&lang=js&"
export * from "./CtintMultipleTabCategoryMain.vue?vue&type=script&lang=js&"
import style0 from "./CtintMultipleTabCategoryMain.vue?vue&type=style&index=0&id=ca12812c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports